import { render, staticRenderFns } from "./review.vue?vue&type=template&id=cab46cb8&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=cab46cb8&lang=less&scoped=true&"
import style1 from "./review.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab46cb8",
  null
  
)

export default component.exports